import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { convertObjectToQueryString } from 'src/utils/functions'
import { OnApplyFiltersParams, UsePostFiltersProps } from './usePostFilters.types'

const usePostFilters = ({ updateQueryParams }: UsePostFiltersProps) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const normalizeFilters = () => {
    const filters = Object.fromEntries(searchParams)
    const validFilters = ['filterReadUnread', 'pubDateOrder', 'myNews', 'scheduled']

    return Object.entries(filters).reduce((acc, [key, value]) => {
      if (validFilters.includes(key)) acc[key] = value
      return acc
    }, {})
  }

  const [filters, setFilters] = useState(normalizeFilters)

  const onApplyFilters = ({ param, value }: OnApplyFiltersParams) => {
    setFilters((prevState) => ({
      ...prevState,
      [param]: value
    }))
  }

  const onClickOnSingleFilter = (event: React.MouseEvent, param: string) => {
    event.preventDefault()

    const button = event.target as HTMLButtonElement
    const isActive = button.classList.contains('_bg-gray-200')

    if (isActive) {
      onApplyFilters({ param, value: 'false' })
      return
    }

    onApplyFilters({ param, value: 'true' })
  }

  const onResetFilters = () => {
    setFilters({})
    navigate(pathname)
  }

  useEffect(() => {
    const filterParams = convertObjectToQueryString(filters)
    const hasValidFilters = Object.keys(filterParams).length > 0

    if (updateQueryParams && hasValidFilters) {
      navigate(`${pathname}?${filterParams}`)
    }
  }, [filters])

  return {
    filters,
    normalizeFilters,
    onApplyFilters,
    onClickOnSingleFilter,
    onResetFilters
  }
}

export default usePostFilters
